import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCDN } from '@/utils/cdn';
import { gettext } from '@/utils/langsBook';
var EmptyList = function(param) {
    var text = param.text;
    return(/*#__PURE__*/ _jsxs("div", {
        className: "w-full text-secondary h-[400px] bg-box rounded-[8px] flex flex-col items-center justify-center",
        children: [
            /*#__PURE__*/ _jsx("img", {
                src: useCDN('/img/empty.png'),
                className: "mb-[20px] w-[180px] h-[165px]",
                alt: "empty"
            }),
            text || gettext('tableEmpty')
        ]
    }));
};
export default EmptyList;
